import React from "react";

import instagram from "images/social/instagram.svg";

import { Trans } from "app/utils";

const InstagramBadge = ({ justIcon, useImageIcon }) => {
  if (justIcon) {
    return (
      <p className="SocialBadge instagram">
        <img height="20px" width="20px" className="social-icon" src={instagram} alt="Instagram icon" />
      </p>
    );
  }

  if (useImageIcon) {
    return (
      <p className="SocialBadge instagram">
        <img height="20px" width="20px" className="social-icon" src={instagram} alt="Instagram icon" />
        <Trans> Instagram</Trans>
      </p>
    );
  }

  return (
    <p className="SocialBadge instagram">
      <svg height="22px" viewBox="0 0 384 384" width="22px" xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g fill="#FFFFFF">
            <g>
              <path d="M352,112 C352,67.81722 316.18278,32 272,32 L112,32 C67.81722,32 32,67.81722 32,112 L32,272 C32,316.18278 67.81722,352 112,352 L272,352 C316.18278,352 352,316.18278 352,272 L352,112 Z M384,112 C384,50.144108 333.855892,0 272,0 L112,0 C50.144108,0 0,50.144108 0,112 L0,272 C0,333.855892 50.144108,384 112,384 L272,384 C333.855892,384 384,333.855892 384,272 L384,112 Z" />
              <circle fillRule="nonzero" cx="292" cy="92" r="20" />
            </g>
            <path d="M192,128 C227.346224,128 256,156.653776 256,192 C256,227.346224 227.346224,256 192,256 C156.653776,256 128,227.346224 128,192 C128.018538,156.661458 156.661458,128.018538 192,128 L192,128 Z M192,96 C245.019336,96 288,138.980664 288,192 C288,245.019336 245.019336,288 192,288 C138.980664,288 96,245.019336 96,192 C96.0251613,138.99109 138.99109,96.0251613 192,96 Z" />
          </g>
        </g>
      </svg>
      <Trans>Instagram</Trans>
    </p>
  );
};

export default InstagramBadge;
